import { getDowntimeWindowErrorMessage } from "encamp-shared/src/portal/getDowntimeWindowErrorMessage";
import { DateTime } from "luxon";

/** Client-side mirror of the API validation; rule and message live in encamp-shared. */
export function getDowntimeWindowError(
  downtimeWindowStart: string | null,
  downtimeWindowEnd: string | null
): string | null {
  const toDate = (iso: string | null) => (iso ? DateTime.fromISO(iso).toJSDate() : null);
  return getDowntimeWindowErrorMessage(toDate(downtimeWindowStart), toDate(downtimeWindowEnd));
}
